import { observe } from 'mobx';

/**
 * @deprecated deprecated. Use MuiLightDarkType from mae/mui-components instead
 */
export type MuiLightDarkType = 'light' | 'dark';
/**
 * @deprecated deprecated. Use LightDarkType from mae/mui-components instead
 */
export type LightDarkType = MuiLightDarkType | 'system';

/**
 * @deprecated deprecated. Use getDarkLightMode from mae/mui-components instead
 */
export function getDarkLightMode(): MuiLightDarkType {
	const userSetting = window.localStorage.getItem('dark-theme');

	if (userSetting === 'false') {
		return 'light';
	} else if (userSetting === 'true') {
		return 'dark';
	}

	return getSystemSetting() ? 'dark' : 'light';
}

/**
 * @deprecated deprecated. Use getMaeLightDarkMode from mae/mui-components instead
 */
export function getMaeLightDarkMode(): LightDarkType {
	const userSetting = window.localStorage.getItem('dark-theme');

	if (userSetting === 'false') {
		return 'light';
	} else if (userSetting === 'true') {
		return 'dark';
	}

	return 'system';
}

/**
 * @deprecated deprecated. Use getSystemSetting from mae/mui-components instead
 */
export function getSystemSetting(): MuiLightDarkType {
	const defaultSetting = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
	return defaultSetting ? 'dark' : 'light';
}

export { observe as maeObserve };
